import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/assets/images/icons/location.svg';
var _hoisted_1 = {
  class: "menu-header"
};
var _hoisted_2 = {
  class: "info"
};
var _hoisted_3 = {
  class: "address"
};
var _hoisted_4 = {
  key: 0,
  class: "store"
};
var _hoisted_5 = {
  class: "location"
};
var _hoisted_6 = {
  class: "info"
};
var _hoisted_7 = {
  class: "store-name van-ellipsis"
};
var _hoisted_8 = {
  class: "distance"
};
var _hoisted_9 = {
  class: "controller"
};
var _hoisted_10 = {
  class: "button-strip"
};
import { computed } from "vue";
import { useShopStoreWithOut } from "@/store/shopStore";
import { useRouter } from "@/hooks/useRouter";
import { useAddress } from "@/hooks/useAddress";
import { useUserStoreWithOut } from "@/store/userStore";
import { OrderTypeEnum } from "@/constant/order";
import SvgIcon from "../base/SvgIcon.vue";
import { useAddressStoreWithOut } from "@/store/addressStore";
import { formatDistance, formatLocation } from "@/utils/format";
import PreparingInfo from "@/components/shop/PreparingInfo.vue";
import { useSupplierStore } from "@/store/supplierStore";
import { showToast } from "@/utils/toastUtil";
import { useI18n } from "vue-i18n";
export default {
  __name: 'MenuHeader',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var _useAddress = useAddress(),
      selfPickUpGetShop = _useAddress.selfPickUpGetShop,
      selfDeliveryGetShop = _useAddress.selfDeliveryGetShop,
      getSelfPickUpDistance = _useAddress.getSelfPickUpDistance,
      getSelfDeliveryDistance = _useAddress.getSelfDeliveryDistance;
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var shopStore = useShopStoreWithOut();
    var userStore = useUserStoreWithOut();
    var addressStore = useAddressStoreWithOut();
    var isDeliveryOn = computed(function () {
      return supplierStore.getIsSupplierSelfDeliverStatus;
    });
    var isPickupOn = computed(function () {
      return supplierStore.getIsSupplierSelfPickupStatus;
    });

    // const type = ref("self_pick_up"); // 是否提取到外部
    var type = computed(function () {
      return userStore.getOrderType;
    });
    var shopName = computed(function () {
      return shopStore.getShopName;
    });
    var selectedAddress = computed(function () {
      return addressStore.getSelectedAddress;
    });
    var distanceOfCurShopCurAddress = computed(function () {
      return getSelfDeliveryDistance();
    });
    var distanceOfCurShopSelfPosition = computed(function () {
      return getSelfPickUpDistance();
    });
    var handleSelectShop = function handleSelectShop() {
      routerPush({
        name: "StoreList"
        // query: {
        //   type: type.value,
        // },
      });
    };
    var handleSwitch = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(targetType) {
        var targetShop, _targetShop;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(targetType === type.value)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!(targetType === OrderTypeEnum.SELF_PICK_UP)) {
                _context.next = 18;
                break;
              }
              if (isPickupOn.value) {
                _context.next = 6;
                break;
              }
              showToast(t("selfPickupNotCurrentlySupported"), 2000);
              return _context.abrupt("return");
            case 6:
              _context.next = 8;
              return selfPickUpGetShop();
            case 8:
              targetShop = _context.sent;
              if (!targetShop) {
                _context.next = 15;
                break;
              }
              _context.next = 12;
              return shopStore.switchShop(targetShop, {
                showToast: true
              });
            case 12:
              userStore.setOrderType(OrderTypeEnum.SELF_PICK_UP);
              // routerReplace({
              //   name: "Menu",
              //   query: {
              //     type: "self_pick_up",
              //   },
              // });
              _context.next = 16;
              break;
            case 15:
              // 理论上不应该没有目标店铺
              showToast(t("storeNotFound"));
            case 16:
              _context.next = 32;
              break;
            case 18:
              if (!(targetType === OrderTypeEnum.SELF_DELIVERY)) {
                _context.next = 32;
                break;
              }
              if (isDeliveryOn.value) {
                _context.next = 22;
                break;
              }
              showToast(t("deliveryNotCurrentlySupported"), 2000);
              return _context.abrupt("return");
            case 22:
              _context.next = 24;
              return selfDeliveryGetShop();
            case 24:
              _targetShop = _context.sent;
              if (!_targetShop) {
                _context.next = 31;
                break;
              }
              _context.next = 28;
              return shopStore.switchShop(_targetShop, {
                showToast: true
              });
            case 28:
              userStore.setOrderType(OrderTypeEnum.SELF_DELIVERY);
              // routerReplace({
              //   name: "Menu",
              //   query: {
              //     type: "self_delivery",
              //   },
              // });
              _context.next = 32;
              break;
            case 31:
              // 否则跳转选择地址
              goToSelectAddress();
            case 32:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleSwitch(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var goToSelectAddress = function goToSelectAddress() {
      routerPush({
        name: "AddressList"
      });
    };

    // onMounted(() => {
    //   const queryPageType = router.currentRoute.value.query.type;
    //   queryPageType && (type.value = queryPageType);
    // });

    return function (_ctx, _cache) {
      var _selectedAddress$valu;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", {
        class: "location",
        onClick: handleSelectShop
      }, [_cache[2] || (_cache[2] = _createElementVNode("img", {
        class: "icon",
        src: _imports_0,
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(shopName.value), 1), _createVNode(SvgIcon, {
        name: "arrow_right",
        class: "icon-right-arrow"
      })]), !isNaN(distanceOfCurShopSelfPosition.value) ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("forYou", [_unref(formatDistance)(distanceOfCurShopSelfPosition.value)])), 1)) : _createCommentVNode("", true), _createVNode(PreparingInfo, {
        class: "prepare-info"
      })])], 512), [[_vShow, type.value === _unref(OrderTypeEnum).SELF_PICK_UP]]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        class: "icon",
        src: _imports_0,
        alt: "",
        onClick: goToSelectAddress
      }), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "address",
        onClick: handleSelectShop
      }, [_createElementVNode("span", null, _toDisplayString(shopName.value), 1), _createVNode(SvgIcon, {
        name: "arrow_right",
        class: "icon-right-arrow"
      })]), _createElementVNode("div", {
        class: "store",
        onClick: goToSelectAddress
      }, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(formatLocation)((_selectedAddress$valu = selectedAddress.value) === null || _selectedAddress$valu === void 0 ? void 0 : _selectedAddress$valu.location)), 1), _createElementVNode("div", _hoisted_8, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "splitor"
      }, null, -1)), _createElementVNode("div", null, _toDisplayString(_unref(formatDistance)(distanceOfCurShopCurAddress.value)), 1), _createVNode(SvgIcon, {
        class: "icon-switch",
        name: "switch"
      })])]), _createVNode(PreparingInfo, {
        class: "prepare-info"
      })])], 512), [[_vShow, type.value === _unref(OrderTypeEnum).SELF_DELIVERY]]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
        class: _normalizeClass(["strip-button hovered", {
          active: type.value === _unref(OrderTypeEnum).SELF_DELIVERY
        }]),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return handleSwitch(_unref(OrderTypeEnum).SELF_DELIVERY);
        })
      }, [_createElementVNode("span", {
        class: "strip-button-text",
        style: _normalizeStyle([{
          "transition": "opacity 0.2s ease 0s",
          "pointer-events": "none"
        }, [!isDeliveryOn.value && type.value !== _unref(OrderTypeEnum).SELF_DELIVERY ? 'opacity: 0.2;' : '']])
      }, _toDisplayString(_ctx.$t("delivery")), 5)], 2), _createElementVNode("div", {
        class: _normalizeClass(["strip-button hovered", {
          active: type.value === _unref(OrderTypeEnum).SELF_PICK_UP
        }]),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return handleSwitch(_unref(OrderTypeEnum).SELF_PICK_UP);
        })
      }, [_createElementVNode("span", {
        class: "strip-button-text",
        style: _normalizeStyle([{
          "transition": "opacity 0.2s ease 0s",
          "pointer-events": "none"
        }, [!isPickupOn.value && type.value !== _unref(OrderTypeEnum).SELF_PICK_UP ? 'opacity: 0.2;' : '']])
      }, _toDisplayString(_ctx.$t("pickupUppercase")), 5)], 2)])])]);
    };
  }
};